



















































































































































import Vue from 'vue';
import Lightbox from '@/components/Lightbox.vue';
import ta2HintsFile from '../assets/ta2-hints.json';

export default Vue.extend({
    
    components: {
        Lightbox,
    },

    data() {
        return {
            ta2Hints: null as any,
        };
    },

    created() {
        this.ta2Hints = ta2HintsFile.map((level) => ({
            title: level.title,
            hints: level.hints.map((hint) => ({ text: hint, hidden: true }))
        }));
    },

    mounted() {
        document.body.classList.remove('gwtp');
        document.body.classList.add('qwok');
    },

    beforeDestroy() {
        document.body.classList.remove('qwok');
        document.body.classList.add('gwtp');
    },
});
